"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSignedIn = void 0;
const react_1 = require("react");
const web_blizzard_reporting_hooks_1 = require("@snapchat/web-blizzard-reporting-hooks");
const Shell_1 = require("../../Shell");
/**
 * Determine if the user is signed-in based on the SSO token returned.
 */
function useIsSignedIn() {
    // See if we can determine from the Observable's current value first.
    // If we can't, we subscribe to the next value.
    const { authStateObservable } = (0, react_1.useContext)(Shell_1.PageContext);
    const determineInitialAuthState = (0, react_1.useCallback)(() => {
        if (!authStateObservable)
            return undefined;
        const authStatus = authStateObservable.getCurrentValue().authStatus;
        if (authStatus === web_blizzard_reporting_hooks_1.AuthStatus.UNKNOWN) {
            return undefined;
        }
        return authStatus === web_blizzard_reporting_hooks_1.AuthStatus.AUTHENTICATED;
    }, [authStateObservable]);
    const [isSignedIn, setIsSignedIn] = (0, react_1.useState)(determineInitialAuthState());
    (0, react_1.useEffect)(() => {
        if (!authStateObservable || isSignedIn !== undefined)
            return;
        const unsubscribe = authStateObservable.subscribe((state) => {
            if (state.authStatus !== web_blizzard_reporting_hooks_1.AuthStatus.UNKNOWN) {
                setIsSignedIn(state.authStatus === web_blizzard_reporting_hooks_1.AuthStatus.AUTHENTICATED);
            }
        });
        return () => {
            unsubscribe();
        };
    }, [authStateObservable, isSignedIn]);
    return isSignedIn;
}
exports.useIsSignedIn = useIsSignedIn;
//# sourceMappingURL=useIsSignedIn.js.map